import { useApi } from '@backstage/core-plugin-api';

import useAsync, { } from 'react-use/lib/useAsync';
import { coreApiRef } from '../api';

export const useCoreApplication = (applicationId) => {
  const ringCoreApi = useApi(coreApiRef);
  return useAsync(() => ringCoreApi.getApplication(applicationId), [applicationId]);
};
